import { render, staticRenderFns } from "./TableDataViewer.vue?vue&type=template&id=547d340a&scoped=true"
import script from "./TableDataViewer.vue?vue&type=script&lang=ts"
export * from "./TableDataViewer.vue?vue&type=script&lang=ts"
import style0 from "./TableDataViewer.vue?vue&type=style&index=0&id=547d340a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d340a",
  null
  
)

export default component.exports